import { NgClass } from '@angular/common';
import { booleanAttribute, ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';

@Component({
	selector: 'sl-dialog',
	changeDetection: ChangeDetectionStrategy.OnPush,
	templateUrl: './dialog.component.html',
	styleUrl: './dialog.component.scss',
	standalone: true,
	imports: [NgClass, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose],
})
export class DialogComponent {
	readonly title = input<string>();
	readonly styleClass = input<string>();
	readonly customClose = input(false, {
		transform: booleanAttribute,
	});
	readonly justifyActionsToStart = input(false, {
		transform: booleanAttribute,
	});

	readonly closeClicked = output<any>();

	onCloseClick(): void {
		this.closeClicked.emit(null);
	}
}
